import { v4 as uuid } from 'uuid';
import { StickyNote } from '../types';

/** Sticky note constructor. Must take an owner. */
export const createStickyNote = (input?: Partial<StickyNote>): StickyNote => ({
  id: input?.id || uuid(),
  content: '',
  habitatID: '',
  color: '',
  ...input,
});
